import { render, staticRenderFns } from "./Metrics.vue?vue&type=template&id=53556910&scoped=true"
import script from "./Metrics.vue?vue&type=script&lang=ts"
export * from "./Metrics.vue?vue&type=script&lang=ts"
import style0 from "./Metrics.vue?vue&type=style&index=0&id=53556910&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53556910",
  null
  
)

export default component.exports